import { defineStore } from 'pinia';
import type { identifier } from '@core/models/base';
import type { OrganizationDisplayModel } from '@shared/models/organizations/organizations';
import { isServiceSuccess } from '@core/models/actionResponse';
import { useOptionalRouteIds } from '@shared/composables/useRouteIds';
import { useOrganizationService } from '../services/organizations.services';
import { PackageTypes } from '@shared/models/packages/packages';
export interface OrganizationState {
  organizationId: identifier;
  studioId: identifier;
  organization?: OrganizationDisplayModel;
}
export const useOrganizationEditorStore = defineStore('organization', {
  state: (): OrganizationState => ({
    organizationId: 0,
    studioId: 0,
    organization: undefined,
  }),
  getters: {
    apiRootUrl: (state) => `/api/studioadmin/studios/${state.studioId}`,
    isSportsOrganization: (state) => state.organization?.type === PackageTypes.SPORT,
    isSchoolsOrganization: (state) => state.organization?.type === PackageTypes.SCHOOL,
  },
  actions: {
    async initialize(studioId?: identifier, organizationId?: identifier) {
      if (!organizationId && organizationId != 0) {
        const [routeOrganizationId, routeStudioId] = useOptionalRouteIds('organizationId', 'studioId');
        studioId = routeStudioId != null ? routeStudioId : undefined;
        organizationId = routeOrganizationId != null ? routeOrganizationId : undefined;
      }
      this.organizationId = organizationId ? (organizationId as identifier) : 0;
      this.studioId = studioId ? (studioId as identifier) : 0;

      await this.updateOrganization();
    },
    async updateOrganization() {
      const { getOrganization } = useOrganizationService(this.studioId);
      if (this.organizationId != 0) {
        const details = await getOrganization(this.organizationId);
        this.organization = isServiceSuccess(details) ? details.data : undefined;
      } else {
        this.clear();
      }
    },
    update(organization: OrganizationDisplayModel) {
      this.organization = organization;
    },
    clear() {
      this.organizationId = this.studioId = 0;
      this.organization = undefined;
    },
  },
});
